import { useRef, useState } from 'react';

import { useQuery } from '@apollo/client';

import { TimeRangeEnum, WalletTypeEnum } from '@libs/backend-common';
import { CurrencyType } from '@libs/types';

import { DashboardTransactionGe } from 'src/components';
import { getPlatformUnderConstructionStatusQuery } from 'src/gql';
import {
  useApiResponse,
  useAppDisclaimer,
  useAssetCmcInfo,
  useCurrency,
  useWalletInfo,
} from 'src/hooks';

import {
  CoinBalance,
  CoinDetailsChart,
  CoinPriceDynamic,
  CoinStatistics,
  PossibleTimeRangeValue,
  OperationsNavigation,
} from './components';

import {
  ChartWrapper,
  CoinBalanceWraper,
  ContentWrapper,
  CustomPageContainer,
  MainContentBoxWRapper,
  MainContentWrapper,
  MobileCoinBalanceWraper,
  TransactionsWrapper,
} from './styles';
import { COIN_DETAILS_SECTION_IDS } from './constants/constants';

// const sections = [
//   { id: 'chartBox', label: 'Section 1', color: 'lightcoral' },
//   { id: 'priceDynamic', label: 'Section 2', color: 'lightblue' },
//   { id: 'statistics', label: 'Section 3', color: 'lightgreen' },
// ];

export const NO_DETAILS_ASSETS = [
  CurrencyType.BGEL,
  CurrencyType.BUSD,
  CurrencyType.USDT,
  CurrencyType.USDC,
  CurrencyType['B-Dollar'],
  CurrencyType['B-Lari'],
];

const getDefaultPageFilters = () => {
  const params = new URLSearchParams(window.location.search);

  const code = params.get('assetCode') as CurrencyType;

  return {
    valueAssetCode: CurrencyType.USD,
    range: TimeRangeEnum.ONE_DAY as PossibleTimeRangeValue,
    code,
  };
};
const CoinDetailsPage = () => {
  const [pageFilters, setPageFilters] = useState(getDefaultPageFilters());

  const { currencySymbol } = useCurrency();

  const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);

  const handlePeriodTabChange = (val: string | number) => {
    setPageFilters((prev) => ({
      ...prev,
      range: val as PossibleTimeRangeValue,
    }));
  };

  const handleCurrencyTabClick = (val: string | number) => {
    setPageFilters((prev) => ({
      ...prev,
      valueAssetCode: val as CurrencyType,
    }));
  };
  // const [activeSection, setActiveSection] = useState(sections[0].id);

  // useEffect(() => {
  //   sectionRefs.current = sectionRefs.current.slice(0, sections.length);

  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         if (entry.isIntersecting) {
  //           setActiveSection(entry.target.id);
  //         }
  //       });
  //     },
  //     { threshold: 0.6 }
  //   );

  //   sectionRefs.current.forEach((ref) => {
  //     if (ref) observer.observe(ref);
  //   });

  //   return () => observer.disconnect();
  // }, []);

  const { filteredData, refetch } = useWalletInfo({
    walletType: WalletTypeEnum.ALL_ASSETS,
    valueAssetCode: pageFilters.valueAssetCode,
    assetCode: pageFilters.code,
  });

  const asset = filteredData?.[0];
  const res = useQuery(getPlatformUnderConstructionStatusQuery);
  const { response } = useApiResponse(res);

  const isUnderConstruction = response?.getPlatformUnderConstructionStatus;
  const { isAppDisclaimerVisible } = useAppDisclaimer();

  const shouldShowStats = !NO_DETAILS_ASSETS.includes(
    pageFilters.code as CurrencyType
  );

  const { assetInfo } = useAssetCmcInfo(pageFilters);

  return (
    <CustomPageContainer>
      {/* {shouldShowStats && (
        <HeaderNavigation
          assetCode={asset?.code}
          activeSection={activeSection}
        />
      )} */}
      <MainContentWrapper>
        <ContentWrapper>
          {asset && (
            <ChartWrapper
              id={COIN_DETAILS_SECTION_IDS.CHART}
              ref={(el) => (sectionRefs.current[0] = el)}
            >
              <CoinDetailsChart
                chartIsVisible={shouldShowStats}
                asset={asset}
                currencySymbol={currencySymbol}
                assetInfo={assetInfo}
                activeTabValue={pageFilters.range}
                handlePeriodTabChange={handlePeriodTabChange}
                refetch={refetch}
              />
            </ChartWrapper>
          )}

          <MobileCoinBalanceWraper>
            {asset && (
              <CoinBalance
                assetCode={asset?.code}
                activeCurrency={pageFilters.valueAssetCode}
                handleTabClick={handleCurrencyTabClick}
              />
            )}
          </MobileCoinBalanceWraper>

          {asset && shouldShowStats && (
            <MainContentBoxWRapper
              id={COIN_DETAILS_SECTION_IDS.DYNAMICPRICE}
              ref={(el) => (sectionRefs.current[1] = el)}
            >
              <CoinPriceDynamic assetCode={asset.code} assetInfo={assetInfo} />
            </MainContentBoxWRapper>
          )}

          {asset && shouldShowStats && (
            <MainContentBoxWRapper
              id={COIN_DETAILS_SECTION_IDS.STATS}
              ref={(el) => (sectionRefs.current[2] = el)}
            >
              <CoinStatistics assetCode={asset.code} assetInfo={assetInfo} />
            </MainContentBoxWRapper>
          )}
          {asset && (
            <TransactionsWrapper>
              <DashboardTransactionGe assetCode={pageFilters.code} />
            </TransactionsWrapper>
          )}

          <MobileCoinBalanceWraper>
            <OperationsNavigation assetCode={pageFilters.code} />
          </MobileCoinBalanceWraper>
        </ContentWrapper>
        <CoinBalanceWraper
          isAppDisclaimerVisible={isAppDisclaimerVisible}
          isUnderConstruction={isUnderConstruction}
        >
          {asset && (
            <CoinBalance
              assetCode={pageFilters.code}
              activeCurrency={pageFilters.valueAssetCode}
              handleTabClick={handleCurrencyTabClick}
            />
          )}
        </CoinBalanceWraper>
      </MainContentWrapper>
    </CustomPageContainer>
  );
};

export default CoinDetailsPage;
